<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Epigraph</a></li>
<li id="level1-front6"><a href="#/front04">Foreword</a></li>
<li id="c01"><a href="#/c01">A Little Taxonomy of Friends</a>
</li>
<li id="c02"><a href="#/c02">A Charming Gift for False Intimacy</a>
</li>
<li id="c03"><a href="#/c03">Best Friends</a>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">The Quickest Way to Kill Friendships</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Friends—Who Needs ’Em?</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">An Extremely Sketchy History of Friendship</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Reciprocity, or Is It Obligation?</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">A Friendship Diary: Adulation, Stimulation, Obligation</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Pity Is at the Bottom of Women</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Boys Will Be Boys</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Petty Details vs. Eternal Verities</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Disparate Friends</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">Cliques and Clans and Communities</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">Talking the Talk</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Techno-Friendships</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">Friendship’s New Rival</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">Broken Friendships</span>
</li>
<li id="c18"><span href="#/c18" title="Link target outside of Sample">Friendlessness</span>
</li>
<li id="c19"><span href="#/c19" title="Link target outside of Sample">Is There an Art of Friendship?</span>
</li>
<li id="level1-back45"><span href="#/back01" title="Link target outside of Sample">A Bibliographical Note</span></li>
<li id="level1-back46"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back47"><span href="#/back03" title="Link target outside of Sample">Index</span></li>
<li id="level1-back48"><span href="#/back04" title="Link target outside of Sample">About the Author</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3fffcfc7